import { IncomeCalcDTO } from '../../models/IncomeCalcDTO.model'
import { IncomeCalcLocation } from '../../models/IncomeCalcLocation.model'
import { USStates } from '../../models/USStates.model'
import ScrubstrApiQueryService, {
  ScrubstrApiQueryServiceGetEvent,
} from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export class IncomeCalcService {
  /**
   * @description Fetches GSA location options for autocomplete
   */
  public async getLocations(event: {
    state: USStates
    startMonth: number
    startYear: number
  }): Promise<IncomeCalcLocation[]> {
    const scrubstrApiQueryRequest: ScrubstrApiQueryServiceGetEvent = {
      endpoint: `income-calc/get-locations`,
      params: {
        startMonth: event.startMonth,
        startYear: event.startYear,
        state: event.state,
      },
    }

    const scrubstrApiQueryService = new ScrubstrApiQueryService()
    return scrubstrApiQueryService.get<IncomeCalcLocation[]>(scrubstrApiQueryRequest)
  }

  /**
   * @description Fetches GSA rates
   */
  public async get(event: {
    state: USStates
    city: string
    startMonth: number
    startDay: number
    startYear: number
  }): Promise<IncomeCalcDTO> {
    const scrubstrApiQueryRequest: ScrubstrApiQueryServiceGetEvent = {
      endpoint: `income-calc/get-rates`,
      params: {
        city: event.city,
        startDay: event.startDay,
        startMonth: event.startMonth,
        startYear: event.startYear,
        state: event.state,
      },
    }

    const scrubstrApiQueryService = new ScrubstrApiQueryService()
    return scrubstrApiQueryService.get<IncomeCalcDTO>(scrubstrApiQueryRequest)
  }
}
